export default {"src":"/kaimono/_next/static/media/shopSelector.8d3b9f0f.svg","height":19,"width":24};